// components/Highlights.tsx
import React, { useEffect } from "react";
import { ClipboardList, Diamond, Gift } from "lucide-react";
import person from "../../assets/person.png";
import bgLayout from "../../assets/bgLayout.png";

export default function Highlights() {
  const highlights = [
    {
      icon: <ClipboardList className="w-6 h-6 text-white" />,
      title: "Chef-led, open kitchen",
      description:
        "Watch dishes come together and hear brief notes on the why behind the flavour",
    },
    {
      icon: <Diamond className="w-6 h-6 text-white" />,
      title: "After-dinner lounge",
      description:
        "Music-led, measured and unhurried a room that lets stories land. Optional arrival portraits",
    },
    {
      icon: <Gift className="w-6 h-6 text-white" />,
      title: "Black-tie, intimate salon",
      description:
        "A considered setting where care, not volume, is the headline",
    },
  ];

  return (
    <section
      className="relative pt-32 pb-40 overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: `url(${bgLayout})` }}
      data-aos="zoom-in"
    >
      {/* Sketch Illustration Right */}
      <div
        className="absolute bottom-0 right-0 w-40 md:w-56 lg:w-64 opacity-90 z-0"
        data-aos="fade-left"
        data-aos-delay="400"
      >
        <img
          src={person}
          alt="Person sketch"
          className="w-full h-full object-contain"
        />
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div
          className="text-center mb-16"
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <p className="text-xs tracking-widest text-[#4E5C36] uppercase mb-4">
            Event Highlights
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 leading-tight">
            An evening of tailored elegance, fine taste, and quiet conversation.
          </h2>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center"
              data-aos="zoom-in-up"
              data-aos-delay={200 * (index + 1)}
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#4E5C36] shadow mb-6">
                {item.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 favela">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
